// extracted by mini-css-extract-plugin
export default {"root":"main_root__sPANf","pd":"main_pd__dQOnP"};